<template>
  <layout :title="title" :defaultShowBottom="true" :share="false">
    <yq-sticky>
      <div class="header">
        <div class="search_warp">
          <img class="search_icon" src="https://i.thsi.cn/iwencai/yuqing/app/search-icon.png" />
          <form action="javascript:;" class="search-form">
            <input
              class="search_input"
              ref="search"
              placeholder="搜索"
              v-model.trim="keyword"
              type="search"
              maxlength="20"
              @keypress="inputKeyPress"
            />
          </form>
          <img
            v-if="keyword"
            class="search_delete"
            src="https://i.thsi.cn/iwencai/yuqing/app/search_delete.png"
            @click="keyword = ''"
          />
        </div>
      </div>
    </yq-sticky>
    <div class="result" v-if="type === 'invest'" style="padding-top: 12px">
      <company-item
        v-for="(item, index) in list"
        :key="index"
        :companyInfo="item"
        @turnToDetail="getDetail(item)"
      ></company-item>
    </div>
    <div class="result" v-else>
      <div v-for="(v, i) in list" :key="i" class="list_item" @click="getDetail(v)">
        <span class="record_text">{{ v.stock_name }}</span>
        <span v-if="v.hq_code" class="stock_code">{{ v.hq_code }}</span>
        <span v-if="v.market_label" :class="getCodeClass(v.hq_market)">{{ v.market_label }}</span>
      </div>
    </div>
    <yq-default v-if="list.length === 0 && !loading && keyword" :absCenter="true"></yq-default>
  </layout>
</template>

<script>
import { stockSearchQuery } from '@api/search';
import { searchCompany } from '@api/jobInvestigate';
import { addHistory } from '@utils/history';
import layout from '@components/layout/default.vue';
import { getCodeClass, getStockDetail } from './data';
import companyItem from  '../job-investigate/components/item';

export default {
  components: { layout, companyItem },
  data() {
    return {
      getCodeClass,
      title: this.$route.query.title || '',
      type: this.$route.query.type || '',
      uid: this.$route.query.uid || '',
      keyword: '',
      list: [],
      loading: true,
    };
  },
  mounted() {
    this.keyword = this.$route.query.keyword || '';
  },
  methods: {
    inputKeyPress(event) {
      if (event.keyCode == 13) {
        event.preventDefault();
        this.search();
        // 添加记录
        const params = {
          biz_code: 'company',
          content: this.keyword,
        };
        addHistory(params);
      }
    },
    search() {
      this.loading = true;
      const params = {
        query: this.keyword,
      };
      if (this.type === 'invest') {
        params.size = 20;
      }
      const _url = this.type === 'invest' ? searchCompany : stockSearchQuery;
      this.$get(_url, params, { loading: true, needCancel: true }).then(res => {
        this.loading = false;
        if (res.status_code === 0) {
          this.list = res.data || [];
        }
      });
    },

    // 查看详情
    getDetail(item) {
      // 添加记录
      const params = {
        biz_code: 'company',
        content: item.org_name,
        visit_type: 1,
        ext: {
          icon: item.logo || '',
          page_type: 'enterprise',
          id: item.org_id,
        },
      };
      addHistory(params);
      //
      const info = {
        name: this.type === 'invest' ? item.org_name : item.stock_name + `（${item.hq_code}）`,
        title: this.title || '',
        id: this.type === 'invest' ? item.org_id : this.uid,
        code: item.hq_code,
        type: this.type,
      };
      getStockDetail(info);
    },
  },
  watch: {
    keyword(val) {
      if (val) {
        this.search();
      } else {
        // 无关键字清空列表
        this.list = [];
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import './public.less';

.header {
  padding: 8px 14px;
  background-color: #fff;
}
.search_warp {
  flex: 1;
  background-color: #f5f5f5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 0 14px;
  height: 34px;
  .search_icon {
    width: 14px;
    height: 14px;
    margin-right: 12px;
  }
  .search-form {
    flex: 1;
  }
  .search_input {
    width: 100%;
    flex: 1;
    background-color: #f5f5f5;
    -webkit-appearance: none;
    -moz-appearance: none;
    line-height: normal;
  }
  ::-webkit-input-placeholder {
    width: 100%;
    flex: 1;
    height: 100%;
    background-color: #f5f5f5;
    line-height: normal;
  }
  .search_delete {
    width: 18px;
    margin-left: 8px;
  }
}
.result {
  // background-color: #fff;
  padding: 0 14px;
}
</style>
